import iFrameBuilder from './iframe-builder';
import PathHelper from './path-helper';
import ENV from '../config/env';

import BRICK_VERSION from '../../../gwi-ads/publisher/src/config/version';

export default class PublisherIframeBuilder extends iFrameBuilder {
  static getFilePath() {
    const brickPath = ENV.publisherBrickPath;
    return `${PathHelper.getBrickPath(brickPath, BRICK_VERSION)}/${ENV.brickIndexFileName}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/publisher-iframe-builder.js